import type { TOC } from '@ember/component/template-only'
import { t } from 'ember-intl'
import RouteTemplate from 'ember-route-template'

export const ManageRolloverStepsStudentsImportPage: TOC<unknown> = <template>
  <div class="mx-auto max-w-3xl px-2">
    <h3 class="text-dusty-black-250 mt-8 mb-6">
      {{t "manage.rollover.steps.students.stepContentHeader"}}
    </h3>
  </div>
  {{outlet}}
</template>

export default RouteTemplate(ManageRolloverStepsStudentsImportPage)
